import { render, staticRenderFns } from "./SalesPointProps.vue?vue&type=template&id=907dc876&"
import script from "./SalesPointProps.vue?vue&type=script&lang=js&"
export * from "./SalesPointProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports